import { pagePath } from "./site-meta.mjs";

export function isSensitiveUrl(value) {
  const url = new URL(value);
  const path = pagePath(url.href);
  return path === "/admin" || path === "/email-preferences"
    || url.pathname.startsWith("/api/admin/")
    || url.pathname === "/api/email-preferences"
    || [...url.searchParams.keys()].some((key) => key.toLowerCase() === "token");
}
